module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAOVBMVEUAAACdm5mcnJicnJicnJmcnJmcm5mdm5qdnJmcm5mcmpmcm5icm5mcm5icm5mcmpmcm5mcm5mcm5n9Utv3AAAAEnRSTlMAmZqfoKKjpqytr93g4uXx8/2Qf3dmAAAAP0lEQVQY02NggAAOIRBgZUAFEFG2gRHl5AIDPrAoL4TDziAohAkEaCbKzAIGPGAuN4TDOChCBwrY+EGACcoDAE43DpDH28fuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/address_add.png
// module id = ljH9
// module chunks = 0